/**
    红包
**/
<template>
  <div style="width: 1200px;
    margin: auto;">
    <!-- 面包屑导航 -->
    <el-breadcrumb class="breakcrumbHeader" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>红包</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row>
      <el-col
        :xs="12"
        :sm="6"
        :md="6"
        :lg="6"
        v-for="(item,index) in envelopeList"
        :key="index"
        class="bigoutBox"
        v-loading="loading"
      >
          <div class="wholeBox" v-if="item.bxyRedEnvelopesList">
            <el-image   class="img-responsive" :src="item.icon">
                <div slot="error" class="image-slot bg-font-size-big">
                    <i class="el-icon-picture"></i>
                </div>
            </el-image>
            <!-- <img  v-if="item.icon!=''?true:false" class="img-responsive" :src="`${item.icon}`" /> -->
            <!-- <div class="img-responsive" v-if="item.icon==''?true:false"><span class="noimg">暂无图片</span></div> -->

            <div class="text_right" style="padding: 14px 0;width: 60%;">
              <span style="font-size: 20px; color: #d93600;height: 32px; margin-top: 15px;">¥<em>{{item.bxyRedEnvelopesList[0].redenvelopesPrice}}</em></span>
              <span class="OneLineDisplay" style="color: #d93600;font-size: 14px">满{{item.bxyRedEnvelopesList[0].subtotal}}元可用</span>
              <div  style="font-size: 12px"><div class="OneLineDisplay" :title="item.bxyRedEnvelopesList[0].mid?`仅可购买 ${item.bxyRedEnvelopesList[0].store_name} 商品`:'通用红包'">{{item.bxyRedEnvelopesList[0].mid?`仅可购买 ${item.bxyRedEnvelopesList[0].store_name} 商品`:'通用红包'}}</div></div>
              <el-button type="text" class="getNow" :disabled='item.flag'  @click="getRedEnveloped(item.bxyRedEnvelopesList[0].axyRid,item.bxyRedEnvelopesList[0].activityId)">立即领取</el-button>
            </div>
          </div>          
      </el-col>
    </el-row>
    <el-row>
        <div class="nodate" v-if="envelopeList.length==0?true:false">
			<div class="first">您还没有相关的优惠券</div>
			<div class="second">店铺红包可享受商品优惠</div>
        </div>
    </el-row>

    <!-- 点击领取后的弹框 -->
    <el-dialog
        :visible.sync="dialogVisible"
        width="30%"
        center
        class="dialogBox">
        <div class="textCenter">领取成功，请在有效期前使用！</div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false" class="buttonBgd">确 定</el-button>
        </span>
    </el-dialog>

  </div>
</template>
<script>
import { redEnvelope,getredEnvelope  } from '@/api/xunyou'
// import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
        dialogVisible: false,
        loading:false,
        envelopeList:[],
    };
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted(){
      this.searchRedEnvelope()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
      // 立即领取红包
      getRedEnveloped(aXyRid,activityId){
        if(this.userInfo.userId==undefined){
            this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },2000)
            return
          }
        //  this.envelopeList.forEach((item)=>{
        //         if(item.bxyRedEnvelopesList[0].aXyRid == aXyRid&&item.isGet==true){
        //             this.$message.info('您的单张券已领取达到上限.')
        //             return
        //         }
                                 
        //     })  
           const req ={
                  aXyRid:aXyRid,
                  muid:this.userInfo.userId,
                  activityId: activityId,//活动id,必填
                }   
             getredEnvelope(req)
            .then(res => {
              if (res.code == 0) {
                this.dialogVisible= true
                this.searchRedEnvelope()
                //    this.envelopeList.forEach((item)=>{
                //     if(item.bxyRedEnvelopesList[0].aXyRid == aXyRid&&item.isGet!=true){
                //         item.isGet = true
                //     }               
                // })  
                  // this.loading = false
                  // this.envelopeList = res.rows;
                  // this.envelopeList.forEach((item)=>{
                  //     item.isGet = false
                  // })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('查询红包失败，请稍后再试！')
            }) 
       
          //  this.envelopeList.forEach((item)=>{
          //       if(item.bxyRedEnvelopesList[0].aXyRid == aXyRid&&item.isGet!=true){
          //           item.isGet = true
          //           this.dialogVisible= true
          //       }else{
          //           this.$message.info('您的单张券已领取达到上限.')
          //       }                
          //   })   
      },

    // 红包查询
      searchRedEnvelope() {
          this.loading = true
         redEnvelope({
           uid:this.userInfo.userId || '',
           status: 0
         })
            .then(res => {
              if (res.code == 0) {
                  this.loading = false
                  this.envelopeList = res.rows;
                  this.envelopeList.forEach((item)=>{
                      item.isGet = false
                  })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('查询红包失败，请稍后再试！')
            })
    },

  },
};
</script>

<style scoped lang='less'>
.breakcrumbHeader{
   margin:15px 0;     
}
.wholeBox {
  display: flex;
  justify-content: flex-start;
  width: 290px;
  height: 126px;
  border: 1px solid #eaeaea;
  padding-right: 10px;
  margin-bottom: 20px;
  box-sizing: border-box;
  cursor: pointer;
  .el-button--text.is-disabled {
      color: #e4e7ed;
      background-color: #999;
  }
}
.img-responsive {
  width: 40%;
  padding: 10px;
  text-align: center;
  line-height: 100px;
  box-sizing: border-box;
}
.getNow {
  /* width: 132px;
  height: 40px; */
  margin-top: 8px;
  background-color: #d93600;
  padding: 7px 15px;
  font-size: 12px;
  color: white;
}
button.el-button.buttonBgd.el-button--primary {
    color: #fff;
    background-color: #ff6700;
    border-color: #e65d00;
    width: 180px;
    margin-left: 12px;
    margin-top: 5px;
    font-size: 14px;
}
.dialogBox .textCenter {
    text-align: center !important;
    font-size: 24px !important;
}
.first {
	margin: 40upx 0 12upx;
	font-size: 28upx;
}

.second {
	font-size: 24upx;
	color: #999;
}
.nodate{
    text-align: center;
    margin-top: 20%;
    font-size: 16px;
}
span.noimg {
    display: inline-block;
    width: 100%;
    background: #ccc;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/redenvelopes/index.vue